import { FC } from "react";

import Krown from "../../../../../../assets/icons/Krown.svg"
import UpTokenCoin from "../../../../../../assets/icons/upTokenCoin.svg";

interface ITableItem {
    player: any,
    isFirstPlace?: boolean,
    key?: number
}

const TableItem: FC<ITableItem> = (props) => {

    const { player, isFirstPlace } = props;

    if(!player){
        return(<div></div>)
    }

    function setColor(): any {
        if(player?.color === "blue")
            return "#3AC1CC";

        if (player?.color === "yellow")
            return "#FFD200";

        if(player?.color === "green") 
            return "#51BD8A"

        if(player?.color === "pink")
            return "#EB078A"
    }
    
    return (
        <div className="table_item">
            <div className="scoreboard_table_row_left"> 
                <img style={{border:`3px solid ${setColor()}`}} className="scoreboard_table_user_image" alt="user" src={`${process.env.REACT_APP_BACKEND_URL}images/${player?.email}.png`} />
                <div className="scoreboard_table_user_name"> {player?.nickName} </div>
                {isFirstPlace && <img className="scoreboard_table_crown_image" alt="crown" src={Krown} />}
            </div>
            <div className="soreboard_table_row_right"> 
                <img className="scoreboard_table_token_image" src={UpTokenCoin} alt="tokens" />
                <div className="scoreboard_table_token_number"> {player?.upper} </div>
            </div>
        </div>
    )
};

export default TableItem;